import { useContext } from "react";
import { LocalizationContext } from "../context/context";
import strings from "../localization";

export const useLocalization = () => {
  const localization = useContext(LocalizationContext);
  return {
    locale: localization,
    strings: strings[localization],
  };
};
